import React from 'react';
import { X, Copy, Check } from 'lucide-react';
import { Prompt, Category } from '../types';
import ImageZoom from './ImageZoom';
import { getCategoryName } from '../utils/category';

interface PromptModalProps {
  prompt: Prompt;
  isOpen: boolean;
  onClose: () => void;
  onMarkerClick?: ( marker: string) => void;
  onEdit?: (prompt: Prompt) => void;
  onDelete?: (id: string) => void;
  userRole?: string;
  categories: Category[];
  currentUserId?: string;
}

const MobilePromptModal: React.FC<
PromptModalProps
> = ({

  onMarkerClick,

  prompt,

  isOpen,

  onClose,

  onEdit,

  onDelete,

  userRole,

  categories,

  currentUserId,

}) => {
  const [copied, setCopied] = React.useState(false);

  const [isMobile, setIsMobile] =
  React.useState(false);

  const handleCopy = async () => {

  try {

    if (navigator.clipboard) {

      await navigator.clipboard.writeText(
        prompt.content
      );

    } else {

      const textArea =
        document.createElement('textarea');

      textArea.value = prompt.content;

      document.body.appendChild(textArea);

      textArea.select();

      document.execCommand('copy');

      document.body.removeChild(textArea);

    }

    setCopied(true);

    setTimeout(() => {

      setCopied(false);

    }, 2000);

  } catch (err) {

    console.error(
      'Erro ao copiar:',
      err
    );

  }

};
  if (!isOpen) return null;
  const canManagePrompt =

  userRole === 'admin'

  ||

  prompt.userId ===
    currentUserId;

    React.useEffect(() => {

  const checkMobile = () => {

    setIsMobile(
      window.innerWidth < 768
    );

  };

  checkMobile();

  window.addEventListener(
    'resize',
    checkMobile
  );

  return () => {

    window.removeEventListener(
      'resize',
      checkMobile
    );

  };

}, []);

  return (

    <div
  className={`

    fixed top-0 left-0 right-0 bottom-20 z-50

    flex

    ${
      isMobile
        ? 'items-start justify-start'
        : 'items-center justify-center p-4'
    }

    bg-black/75

  `}
>
      <div
  className={`

    bg-dark-800
    border border-dark-700
    overflow-x-hidden
    flex flex-col
    touch-pan-y

    ${
      isMobile
        ? `
          w-full
h-screen
rounded-none
overflow-y-auto
        `
        : `
          rounded-lg
          max-w-3xl
          w-full
          mx-2
          sm:mx-4
          h-[90vh]
          max-h-[90vh]
          overflow-hidden
        `
    }

  `}
>
        <div
  className="

    sticky
    top-0
    z-20
    shrink-0

    flex
    items-center
    justify-between

    p-3
    sm:p-5

    border-b
    border-dark-700

    bg-dark-800/95
    backdrop-blur-lg

  "
>
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 bg-purple-900/30 text-purple-300 text-sm rounded-full">
              {
  getCategoryName(
    prompt.categoryId,
    categories,
    prompt.categoryName
  )
}
            </span>
            {prompt.identifier && (
              <span className="text-dark-300 text-sm">
                {prompt.identifier}
              </span>
            )}
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-dark-700 rounded transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div
          className={
            isMobile
              ? 'flex-1'
              : 'flex-1 min-h-0 flex flex-col'
          }
        >
          {prompt.imageUrl && (
  <div
    className={
      isMobile
        ? 'border-b border-dark-700 bg-dark-900'
        : 'shrink-0 basis-[68%] min-h-0 border-b border-dark-700 bg-dark-900 p-4 sm:p-5'
    }
  >
    <div className="px-4 pt-4">
  <div className="mx-auto w-full max-w-[440px] sm:max-w-[480px]">
    <ImageZoom
      src={prompt.imageUrl}
      alt="Prompt"
      showResetButton={true}
    />
  </div>
</div>
  </div>
)}

          <div
            className={
              isMobile
                ? 'p-4 sm:p-6 space-y-5'
                : `${prompt.imageUrl ? 'basis-[32%]' : 'flex-1'} min-h-0 overflow-y-auto p-4 sm:p-5 space-y-5`
            }
          >
            {prompt.observation && (
              <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 text-dark-100 shadow-sm">
                <div className="mb-2 text-sm font-semibold text-purple-300">Observação</div>
                <p className="whitespace-pre-wrap text-dark-100 leading-relaxed">
                  {prompt.observation}
                </p>
              </div>
            )}

            <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 overflow-hidden">
              <div className="mb-3 text-sm font-semibold text-purple-300">Prompt</div>
              <div className="max-h-[50vh]
sm:max-h-72 overflow-y-auto rounded-lg bg-dark-950 p-4">
                <pre className="whitespace-pre-wrap break-words font-mono text-dark-100 leading-relaxed">
                  {prompt.content}
                </pre>
              </div>
            </div>

            {prompt.markers &&
 prompt.markers.length > 0 && (

  <div className="rounded-xl border border-dark-700 bg-dark-900 p-4">

    <div className="mb-3 text-sm font-semibold text-purple-300">
      Marcadores
    </div>

    <div className="flex flex-wrap gap-2">

      {prompt.markers.map((marker) => (

        <button
  key={marker}
  type="button"
  onClick={() =>
    onMarkerClick?.(marker)
  }
  className="
    px-3
    py-1
    rounded-full
    bg-purple-900/30
    text-purple-300
    text-sm
    hover:bg-purple-800/40
    transition-colors
    cursor-pointer
  "
>
  #{marker}
</button>

      ))}

    </div>

  </div>

)}

            {prompt.variations && prompt.variations.length > 0 && (
              <div className="rounded-xl border border-dark-700 bg-dark-900 p-4 overflow-hidden">
                <div className="mb-3 text-sm font-semibold text-purple-300">
                  Variações ({prompt.variations.length})
                </div>
                <div className="space-y-3">
                  {prompt.variations.map((variation, index) => (
                    <div key={index} className="border-l-2 border-purple-500/30 pl-4">
                      <div className="text-xs text-dark-400 mb-1">Var {index + 1}</div>
                      <div className="max-h-48 overflow-y-auto rounded-lg bg-dark-950 p-3">
                        <pre className="whitespace-pre-wrap break-words font-mono text-dark-100 leading-relaxed text-sm">
                          {variation}
                        </pre>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="border-t border-dark-700 pt-5">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

                <div className="flex justify-end">
                  <button
                    onClick={handleCopy}
                    className="flex items-center gap-2 btn-primary"
                  >
                    {copied ? (
                      <>
                        <Check size={18} />
                        Copiado!
                      </>
                    ) : (
                      <>
                        <Copy size={18} />
                        Copiar prompt
                      </>
                    )}
                    
                  </button>
                </div>


 {canManagePrompt && (
                <div className="flex flex-wrap gap-3">
                   
                  {onEdit && (
                    
                    <button
                      type="button"
                      onClick={() => onEdit(prompt)}
                      className="btn-secondary"
                    >
                      Editar
                    </button>
                  )}
                 
                  {onDelete && (
                    <button
                      type="button"
                      onClick={() => onDelete(prompt.id)}
                      className="btn-secondary text-red-400 hover:text-red-200"
                    >
                      Excluir
                    </button>
                  )}
                  
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
  };

export default MobilePromptModal;
